/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { FindOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/partners';

export const PartnerApi = {
  findPartnerForForecastQuantity: async (option: FindOptions) => {
    let url = `${pathname}/forecast`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  find: async (option: FindOptions) => {
    let url = pathname;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string, option: FindOptions) => {
    let url = `${pathname}/${id}`;

    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findOnePartnerForCRM: async (id: string) => {
    const url = `${pathname}/find-partner-for-crm/${id}`;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findAllPartner: async (option: FindOptions) => {
    let url = `${pathname}/find-partner`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findPartnerForShippingList: async (option: FindOptions) => {
    let url = `${pathname}/add-to-entity-shipping-list`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  checkPermissionEditWithPartner: async (option: any) => {
    let url = `${pathname}/check-permission-edit-with-partner`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  syncProductsInChain: async (body: SyncProductsInChainBody) => {
    const url = `${pathname}/sync-products-in-chain`;
    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateNote: async (id: string, body: UpdatePartnerNoteBody) => {
    const url = `${pathname}/${id}/note`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateEntityPolicyMulti: async (body: UpdateEntityPolicyMultiBody) => {
    const url = `${pathname}/multi`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateStatus: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}/status`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  approve: async (body: any = {}) => {
    const url = `${pathname}/approve`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (data: CreatePartnerData) => {
    try {
      const response = await entityService.post(pathname, data);
      return response;
    } catch (error) {
      throw error;
    }
  },

  removePricePolicy: async (id: string) => {
    const url = `${pathname}/${id}/remove-price-policy`;

    try {
      const response = await entityService.patch(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  removePricePolicyMulti: async (body: { partnerIDs: string[] }) => {
    const url = `${pathname}/multi/remove-price-policy`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  removeProposalPolicy: async (id: string) => {
    const url = `${pathname}/${id}/remove-proposal-policy`;

    try {
      const response = await entityService.patch(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  removeProposalPolicyMulti: async (body: { partnerIDs: string[] }) => {
    const url = `${pathname}/multi/remove-proposal-policy`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateGroupMulti: async (body: { partnerIDs: string[]; groupID: string }) => {
    const url = `${pathname}/multi/update-group`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updatePartnerType: async (
    body: { partnerType: number },
    partnerID: string
  ) => {
    const url = `${pathname}/update-type/${partnerID}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteGroupMulti: async (body: { partnerIDs: string[] }) => {
    const url = `${pathname}/multi/delete-group`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateGroup: async (body: { partnerID: string; groupID: string }) => {
    const url = `${pathname}/update-group`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updatePolicy: async (
    id: string,
    body: { pricePolicyID?: string; proposalPolicyID?: string }
  ) => {
    const url = `${pathname}/${id}/update-policy`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteGroup: async (id: string) => {
    const url = `${pathname}/${id}/delete-group`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findToCheckDuplicate: async (option: {
    partnerCode: string;
    entityID: string;
  }) => {
    let url = `${pathname}/check-duplicate-partner`;
    const query = serialize(option);
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findPartnerForCreateCentralEntityPolicy: async (
    option: FindPartnerForCreateCentralEntityPolicy
  ) => {
    let url = `${pathname}/find-partner-for-create-central-entity-policy`;
    const query = serialize(option);
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findPartnerForFullOrderQuantitySetting: async (
    option: FindPartnerForCreateCentralEntityPolicy
  ) => {
    let url = `${pathname}/find-for-full-order-quantity-setting`;
    const query = serialize(option);
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findPartnerForUpdateEntityPolicy: async (
    option: FindPartnerForUpdateEntityPolicyQuery
  ) => {
    let url = `${pathname}/find-partner-for-update-entity-policy`;
    const query = serialize(option);
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findChainEntityAndPartnerForUpdateEntityPolicy: async (
    option: FindPartnerForUpdateEntityPolicyQuery
  ) => {
    let url = `${pathname}/find-chain-entity-and-partner-for-update-entity-policy`;
    const query = serialize(option);
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findPartnerEntityPolicy: async (option: FindPartnerEntityPolicyQuery) => {
    let url = `${pathname}/find-partner-entity-policy`;
    const query = serialize(option);
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findChainEntityAndPartnerEntityPolicy: async (
    option: FindPartnerEntityPolicyQuery
  ) => {
    let url = `${pathname}/find-chain-entity-and-partner-entity-policy`;
    const query = serialize(option);
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findDebtProofInfo: async id => {
    const url = `${pathname}/find-debt-proof-info/${id}`;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findCustomerPartner: async (option: FindOptions, body: FindPartnerBody) => {
    let url = `${pathname}/find-customer-partner`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findBranchPartner: async (option: FindOptions, body: FindPartnerBody) => {
    let url = `${pathname}/find-branch-partner`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findSupplierPartner: async (option: FindOptions, body: FindPartnerBody) => {
    let url = `${pathname}/find-supplier-partner`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findWarehousePartner: async (option: FindOptions, body: FindPartnerBody) => {
    let url = `${pathname}/find-warehouse-partner`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findCustomerPartnerForCreateDigitalMenu: async (option: FindOptions) => {
    let url = `${pathname}/find-partner-for-create-digital-menu`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  exportPartner: async (body: ExportPartnerBody) => {
    const url = `${pathname}/export`;
    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  exportPartnerSupplier: async () => {
    const url = `${pathname}/export-supplier`;
    try {
      const response = await entityService.post(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  exportPartnerCustomer: async () => {
    const url = `${pathname}/export-customer`;
    try {
      const response = await entityService.post(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  exportPartnerBranch: async () => {
    const url = `${pathname}/export-branch`;
    try {
      const response = await entityService.post(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  exportPartnerWarehouse: async () => {
    const url = `${pathname}/export-warehouse`;
    try {
      const response = await entityService.post(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findSupplierPartnerForCreateDigitalMenu: async (
    body: FindSupplierPartnerForCreateDigitalMenuBodyDto
  ) => {
    const url = `${pathname}/find-partner-supplier-for-create-digital-menu`;
    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findPartnersInGroup: async (groupID: string, option: FindOptions) => {
    let url = `${pathname}/find-partner-in-group/${groupID}`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findPartnersForAddPartnerInGroup: async (
    groupID: string,
    option: FindOptions
  ) => {
    let url = `${pathname}/find-partner-for-add-customer-in-group/${groupID}`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findPartnerForCreateGroup: async (option: FindOptions) => {
    let url = `${pathname}/find-partner-for-create-group`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  generatePartnerCode: async (option: GeneratePartnerCodeQuery) => {
    let url = `${pathname}/generate-code`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findPartnerWaitingForApproveConnect: async (option: FindOptions) => {
    let url = `${pathname}/find-partner-waiting-to-approve`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  checkDuplicate: async (option?: CheckDuplicatePartnerCodeQuery) => {
    let url = `${pathname}/check-duplicate`;
    const query = serialize(option || {});
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findAvailableEntityForUpdateChainEntity: async (
    option: FindAvailableEntityForUpdateChainEntityOption
  ) => {
    let url = `${pathname}/find-available-entity-for-update-connect`;
    const query = serialize(option || {});
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findPartnerTypeInChain: async (id: string) => {
    const url = `${pathname}/find-partner-type-in-chain/${id}`;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updatePartnerIsCalculatorDebt: async (
    body: UpdatePartnerIsCalculatorDebtBody
  ) => {
    const url = `${pathname}/update-is-calculator-debt`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateForecastSettings: async (
    id: string,
    body: UpdateForecastSettingBody
  ) => {
    const url = `${pathname}/update-forecast-settings/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateShouldForecastQuantity: async (
    id: string,
    body: UpdatePartnerShouldForecastQuantityBody
  ) => {
    const url = `${pathname}/update-should-forecast-quantity/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateMultiSettingPartners: async (body: any) => {
    const url = `${pathname}/multi/setting`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface CreatePartnerData {
  isSelectAllProduct?: boolean;
  supplierProductIDs?: string[];
  invitationID: string;
  groupID: string;
  entityPricePolicyID?: string;
  entityProposalPolicyID?: string;
  shouldCreateDigitalMenu?: boolean;
  shouldSyncEntityCategory?: boolean;
  shouldCreateNewProduct?: boolean;
  code?: string;
}

export interface FindPartnerForDuplicateMenuType {
  id: string;
  isLinked: boolean;
  isChainEntity: boolean;
  displayName: string;
  code: string;
  phoneNumber: string;
  avatar: string;
  name: string;
  email: string;
  slug: string;
  type: string | number;
  partnerStatus?: number | null;
  partnerCode: string;
  groupID?: string | null;
  wardID?: string | null;
  entityProposalPolicyID?: string | null;
  entityPricePolicyID?: string | null;
  ward?: any;
}

export interface SyncProductsInChainBody {
  entities: SyncProductsInChainEntity[];
}

interface SyncProductsInChainEntity {
  id: string;
  partnerPathIDs: string[];
  entityProductIDs: string[];
  isInChain: boolean;
  partnerPaths: any[];
}

export interface FindPartnerForCreateCentralEntityPolicy {
  name?: string;
  policyType: 'PROPOSAL_POLICY' | 'PRICE_POLICY';
}

export interface FindPartnerForUpdateEntityPolicyQuery {
  entityID?: string;
  name?: string;
  policyType: 'PROPOSAL_POLICY' | 'PRICE_POLICY';
  entityPolicyID: string;
  status: number;
}

export interface FindPartnerEntityPolicyQuery {
  entityID?: string;
  name?: string;
  policyType: 'PROPOSAL_POLICY' | 'PRICE_POLICY';
  entityPolicyID: string;
  status: number;
}

export interface UpdateEntityPolicyMultiBody {
  partners: Array<UpdateEntityPolicyMultiBodyItem>;
}

export interface UpdateEntityPolicyMultiBodyItem {
  id: string;
  entityPricePolicyID?: string;
  entityProposalPolicyID?: string;
}

export interface PartnerNoteDescription {
  id: string;
  value: string;
  action?: 'add' | 'update' | 'delete';
}

export interface PartnerNote {
  id: string;
  type: number;
  isDefault?: boolean;
  title: string;
  description?: PartnerNoteDescription[];
  color?: string;
  action: 'add' | 'update' | 'delete';
  updatedAt?: string;
}

export interface UpdatePartnerNoteBody {
  note: PartnerNote[];
}

export interface ExportPartnerBody {
  partnerType: number;
}

export interface FindSupplierPartnerForCreateDigitalMenuBodyDto {
  supplierID: string;
  customerID: string;
}

export interface GeneratePartnerCodeQuery {
  partnerType: number;
}

export interface CheckDuplicatePartnerCodeQuery {
  code: string;
  partnerType: number;
}

export interface FindAvailableEntityForUpdateChainEntityOption {
  targetEntityID: string;
  partnerType: number;
  chainEntityID: string;
}

export interface UpdatePartnerIsCalculatorDebtBody {
  partnerID: string;
  isCalculatorDebt: boolean;
}

export interface UpdateForecastSettingBody {
  shouldFreezeMenu?: boolean;
  enableForecastMode?: number;
}

export interface UpdatePartnerShouldForecastQuantityBody {
  shouldForecastQuantity?: boolean;
}

export interface FindPartnerBody {
  groupIDs?: string[];
  entityIDs?: string[];
}
